import { render } from "./image-upload.vue?vue&type=template&id=75ef8f4a"
import script from "./image-upload.vue?vue&type=script&lang=ts"
export * from "./image-upload.vue?vue&type=script&lang=ts"

import "./image-upload.vue?vue&type=style&index=0&id=75ef8f4a&lang=scss"
script.render = render

export default script